// extracted by mini-css-extract-plugin
module.exports =  {"root":"MP_wDLonLK1Gp93kjvEP"};